export default __webpack_public_path__ + "static/media/endContract.04891c14.svg";